import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { async } from "rxjs";
import LocationListService from "../../services/LocationListService";

const initialState = {
  data: [],
  columnConfig: [],
  status: "idle",
  formData: {},
  dimentionList: []
};

export const fetchLocationList = createAsyncThunk("locationList", async () => {
    const response = await LocationListService.getLocationList();
    return response;
})

export const fetchLocationDimentionList = createAsyncThunk("locationDimentionList", async () => {
  const response = await LocationListService.getLocationDimentionList();
  return response;
})

export const LocationListSlice = createSlice({
  name: "locationList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLocationList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchLocationList.fulfilled, (state, action) => {
        state.status = "idle";
        state.data = action.payload;
      })
      .addCase(fetchLocationDimentionList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchLocationDimentionList.fulfilled, (state, action) => {
        state.status = "idle";
        state.dimentionList = action.payload;
      });
  },
});

export const selectLocationList = (state) => state.locationList.data

export const selectLocationDimentionList = (state) => state.locationList.dimentionList

export default LocationListSlice.reducer;